import { createSlice } from "@reduxjs/toolkit";
import { getTeacherMeetings } from "./teacher-meeting-thunk";

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: null,
};

export const teacherCourseDataSlice = createSlice({
  name: "content",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTeacherMeetings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTeacherMeetings.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(getTeacherMeetings.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.success = false;
    });
  },
});

export default teacherCourseDataSlice.reducer;
